/**
 * RegExp to validate a CSS size value (width, height, etc.) or 'auto'
 */
const CSS_SIZE_VALIDATION_REGEX =
  /^(auto|(-?(\d*\.)?\d+)((px)|(em)|(%)|(ex)|(ch)|(rem)|(vw)|(vh)|(vmin)|(vmax)|(cm)|(mm)|(in)|(pt)|(pc)))$/;

/**
 * Returns value if it's a valid CSS size value, or undefined otherwise.
 *
 * @param value - the value to validate.
 * @returns the validated string or undefined otherwise.
 */
export function validateCSSSize(value: string): string | undefined {
  return CSS_SIZE_VALIDATION_REGEX.test(value) ? value : undefined;
}
